@if (!isMobile) {
    <div class="title">
        <span>{{ 'TITLES.LIVE_CAPACITY' | translate }}</span>
    </div>
    <mat-divider class="top-divider"></mat-divider>
    @if(user_role_id == 5 || user_role_id == 6){
        <div class="dflex">
            <label class="container-extra" rtlDiv>
              <input id="isUnfilteredTransmission_chc" [(ngModel)]="isUnfilteredTransmission" [checked]="isUnfilteredTransmission" type="checkbox" (change)="unfilteredTransmissionBtn(isUnfilteredTransmission)" rtlDiv>
              <span class="checkmark" rtlDiv></span>
              <div class="chbx-title">{{ 'LIVE_INFO.UNFILTERED' | translate }}</div>
            </label>
        </div>
    }
    <div [ngClass]="{'hideCmp': isUnfilteredTransmission}">
        <app-filtered-samples [binLiveInfo_Bin]="binLiveInfo_Bin"></app-filtered-samples>
    </div>
    <div [ngClass]="{'hideCmp': !isUnfilteredTransmission}">
        <app-unfiltered-samples [binLiveInfo_Bin]="binLiveInfo_Bin"></app-unfiltered-samples>
    </div>
}

@if (isMobile) {
    <div class="mobile-header">
        <span class="mobile-title"> {{ 'TITLES.Mobile_LIVE_CAPACITY' | translate }}</span>
    </div>
    <mat-divider class="mobile-top-divider"></mat-divider>
    @if(user_role_id == 5 || user_role_id == 6){
        <div class="dflex">
            <label class="container-extra" rtlDiv>
              <input id="isUnfilteredTransmission_chc" [(ngModel)]="isUnfilteredTransmission" [checked]="isUnfilteredTransmission" type="checkbox" (change)="unfilteredTransmissionBtn(isUnfilteredTransmission)" rtlDiv>
              <span class="checkmark" rtlDiv></span>
              <div class="chbx-title">{{ 'LIVE_INFO.UNFILTERED' | translate }}</div>
            </label>
        </div>
    }
    <div [ngClass]="{'hideCmp': isUnfilteredTransmission}">
        <app-filtered-samples (rangeBtnEvent)="rangeBtnEventHander($event)" [binLiveInfo_Bin]="binLiveInfo_Bin"></app-filtered-samples>
    </div>
    <div [ngClass]="{'hideCmp': !isUnfilteredTransmission}">
        <app-unfiltered-samples (rangeBtnEvent)="rangeBtnEventHander($event)" [binLiveInfo_Bin]="binLiveInfo_Bin"></app-unfiltered-samples>
    </div>
}
